/* =========================================================================
   Lagoon 8·8·8 Leaderboard — Booster/Shopify build (Phase 1, two programs)
   ---------------------------------------------------------------------------
   Self-mounting. For every [data-lg888-board] it reads config from data-attrs
   (set by the section schema) and renders the board:

     data-endpoint  Google Apps Script web-app URL (blank = local/demo mode)
     data-start     official kickoff date, YYYY-MM-DD
     data-days      number of consecutive days needed to finish (default 8)
     data-season-start / data-season-end
                    the FULL loggable range. Athletes may run any data-days
                    CONSECUTIVE days inside it ("flexible start"), so logging is
                    open across the whole range, not just the official window.
                    Defaults to the calendar month containing data-start.
     data-sample    "true" to seed the demo roster in local mode

   • Two programs: ELITE (8 miles/day) and OPEN (8,000 steps/day). Each athlete
     picks one; the board ranks fairly across both on DAYS COMPLETED (goal
     progress as tiebreak) and the Activity column adapts its unit per row.
   • Manual check-ins matched by EMAIL (logging another day updates one row).
   • Persists to localStorage; with an endpoint set, reads/writes a shared
     Google Sheet. Entry columns: category, value (miles OR steps), hours.
   • Phase 2 swaps manual rows for synced Oura/Whoop/Strava; the row schema
     (source + verified) already supports it.
   ========================================================================= */
(function () {
  "use strict";

  function boot(root) {
    if (root.__lg888Booted) return;
    root.__lg888Booted = true;

    var ENDPOINT   = (root.getAttribute("data-endpoint") || "").trim();
    var START      = (root.getAttribute("data-start") || "2026-08-08").trim();
    var DAYS       = parseInt(root.getAttribute("data-days") || "8", 10) || 8;
    var USE_SAMPLE = (root.getAttribute("data-sample") || "true") === "true";
    var LIVE = !!ENDPOINT;
    var LS_KEY = "lagoon888:entries:v2:" + START;
    // Admin mode: add ?admin=1 to the page URL to manage/delete every check-in.
    var ADMIN = /[?&]admin=1\b/.test(location.search);

    var WINDOW = (function () {
      var out = [], d = new Date(START + "T00:00:00");
      for (var k = 0; k < DAYS; k++) { out.push(iso(d)); d.setDate(d.getDate()+1); }
      return out;
    })();

    /* SEASON = the full loggable range. Defaults to the calendar month that
       contains START so late starters can always log; override per season with
       the section's season start/end settings. */
    var SEASON = (function(){
      var s = (root.getAttribute("data-season-start") || "").trim();
      var e = (root.getAttribute("data-season-end") || "").trim();
      if (!s || !e){
        var d = new Date(START + "T00:00:00");
        var first = new Date(d.getFullYear(), d.getMonth(), 1);
        var last  = new Date(d.getFullYear(), d.getMonth()+1, 0);
        s = s || iso(first);
        e = e || iso(last);
      }
      if (e < s) e = s;
      return { start:s, end:e };
    })();
    var STREAK_LEN  = DAYS;                    // consecutive days needed
    var SEASON_DAYS = daysBetween(SEASON.start, SEASON.end);
    var TODAY = clampSeason(iso(new Date()));
    var REF   = TODAY;                         // "now" for week/month/day filters

    function iso(d){
      return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0");
    }
    function clampSeason(s){
      if (s < SEASON.start) return SEASON.start;
      if (s > SEASON.end)   return SEASON.end;
      return s;
    }
    function daysBetween(from, to){
      var out = [], d = new Date(from + "T00:00:00"), end = new Date(to + "T00:00:00");
      while (d <= end){ out.push(iso(d)); d.setDate(d.getDate()+1); }
      return out;
    }
    function addDays(s, n){
      var d = new Date(s + "T00:00:00");
      d.setDate(d.getDate()+n);
      return iso(d);
    }

    // Program definitions
    var GOAL = { elite: 8, open: 8000 };
    var UNIT = { elite: "mi", open: "steps" };
    // Used to score an Elite (miles) day against the Open (steps) bar, so a
    // runner who misses 8 miles can still bank the day as an Open finisher day.
    var STEPS_PER_MILE = 2000;
    function goalOf(cat){ return GOAL[cat] || GOAL.elite; }
    function unitOf(cat){ return UNIT[cat] || UNIT.elite; }

    // ======================================================================
    // SAMPLE ROSTER  [name, ig, city, state, source, quality, category]
    // ======================================================================
    function seedRand(s){ return function(){ s=(s*9301+49297)%233280; return s/233280; }; }
    var ROSTER = [
      ["Natalie Wagner","marathonnatalie","Oxon Hill","MD","Oura",   0.97,"elite"],
      ["Chris Putsch","chris_putsch","West Chester","PA","Whoop",    0.95,"elite"],
      ["Ryan Hurley","lagoonsleep","Minneapolis","MN","Oura",        0.93,"open"],
      ["Amanda Daghent","amandaghent","Rock Hill","SC","Strava",     0.92,"elite"],
      ["Darius Nabors","dariusnabors","Charlottesville","VA","Whoop",0.90,"open"],
      ["Jaci Wilson","jaci.wilson.runs","Fergus Falls","MN","Oura",  0.88,"elite"],
      ["Kevin Hopp","hoppcantstop","Bartlett","IL","Strava",         0.86,"open"],
      ["Bryn Saunders","brynsaunders","New Bedford","MA","Manual",   0.84,"open"],
      ["Mykera James","bypassingthetime84","Houston","TX","Oura",    0.82,"elite"],
      ["Corbin Ellis","corbin325","Campbellsville","KY","Whoop",     0.80,"open"],
      ["Randy Soto","ran.the.man.sav","Houston","TX","Strava",       0.74,"elite"],
      ["Mandy Vermeer","denvermandyj","Annapolis","MD","Manual",     0.70,"open"],
      ["CB Harlow","runningcb","Fayetteville","AR","Oura",           0.66,"elite"],
      ["Lola Marsh","lolascurls_official","Minneapolis","MN","Manual",0.60,"open"]
    ];
    function sampleAthletes(){
      return ROSTER.map(function (a, i) {
        var rnd = seedRand(1000 + i * 37), q = a[5], cat = a[6];
        var days = WINDOW.map(function (date) {
          var hit = rnd() < q;
          var value = cat === "open"
            ? Math.round(hit ? 8000 + rnd()*3500 : 4500 + rnd()*3200)
            : +((hit ? 8 + rnd()*3 : 4 + rnd()*3.5)).toFixed(1);
          return { date: date, value: value,
            hours: hit ? +(8 + rnd()*0.9).toFixed(1) : +(6 + rnd()*1.8).toFixed(1),
            score: a[4] === "Manual" ? null : Math.round(62 + q*28 + rnd()*8) };
        });
        var byDate = {};
        days.forEach(function(d){ byDate[d.date] = d; });
        return { name:a[0], instagram:a[1], city:a[2], state:a[3],
                 source:a[4], verified:a[4] !== "Manual", category:cat,
                 days:days, byDate:byDate };
      });
    }

    // ======================================================================
    // ENTRIES → athletes  (identity key = email)
    // ======================================================================
    function keyOf(e){ return String(e.email || e.instagram || e.name || "").toLowerCase().trim(); }
    function catOf(v){ return String(v||"").toLowerCase()==="open" ? "open" : "elite"; }
    function normDate(v){
      if (v == null) return "";
      var s = String(v);
      var m = s.match(/^\d{4}-\d{2}-\d{2}/);
      if (m) return m[0];
      var d = new Date(s);
      if (!isNaN(d.getTime())){
        return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0");
      }
      return s;
    }
    function upsertEntry(list, e){
      var k = keyOf(e);
      for (var i = 0; i < list.length; i++){
        if (keyOf(list[i]) === k && list[i].date === e.date){ list[i] = e; return list; }
      }
      list.push(e); return list;
    }
    function athletesFromEntries(entries){
      var byKey = {};
      entries.forEach(function(e){
        var k = keyOf(e); if (!k) return;
        if (!byKey[k]) byKey[k] = { name:"", instagram:"", city:"", state:"",
                                    source:"Manual", verified:false, category:"elite", _days:{} };
        var a = byKey[k];
        if (e.name) a.name = e.name;
        if (e.instagram) a.instagram = e.instagram;
        if (e.city) a.city = e.city;
        if (e.state) a.state = e.state;
        if (e.category) a.category = catOf(e.category);
        a._days[e.date] = { date:e.date, value:+e.value||0, hours:+e.hours||0,
                            cat:catOf(e.category), score:null };
      });
      return Object.keys(byKey).map(function(k){
        var a = byKey[k];
        a.byDate = a._days;
        // Span the whole season, not just the official days, so late starters
        // and self-selected windows are scored on everything they logged.
        a.days = SEASON_DAYS.map(function(d){ return a._days[d] || { date:d, value:0, hours:0, cat:a.category, score:null }; });
        delete a._days; return a;
      });
    }

    // ======================================================================
    // STORE — localStorage + optional Google Sheets
    // ======================================================================
    var ENTRIES = [];
    var SYNC_MSG = "";
    function loadLocal(){ try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; } catch(e){ return []; } }
    function saveLocal(){ try { localStorage.setItem(LS_KEY, JSON.stringify(ENTRIES)); } catch(e){} }
    /* Tolerant column lookup — matches sheet headers regardless of case,
       spacing or underscores, and accepts common aliases. */
    function pickField(row, names){
      var map = {};
      Object.keys(row).forEach(function(k){ map[String(k).toLowerCase().replace(/[\s_]/g,"")] = row[k]; });
      for (var i=0; i<names.length; i++){
        var v = map[names[i]];
        if (v !== undefined && v !== null && String(v).trim() !== "") return v;
      }
      return undefined;
    }
    function mapSheetRow(r){
      return {
        email:     pickField(r,["email","emailaddress","e-mail"]) || "",
        name:      pickField(r,["name","fullname","athlete"]) || "",
        instagram: pickField(r,["instagram","ig","handle"]) || "",
        city:      pickField(r,["city"]) || "",
        state:     pickField(r,["state","st"]) || "",
        category:  catOf(pickField(r,["category","program","division"])),
        date:      normDate(pickField(r,["date","day","checkindate"])),
        value:    +(pickField(r,["value","miles","steps","run","distance","activity"]) || 0),
        hours:    +(pickField(r,["hours","sleep","hoursinbed","sleephours"]) || 0)
      };
    }

    function fetchSheet(){
      return fetch(ENDPOINT, { method:"GET" })
        .then(function(r){ return r.text().then(function(t){ return { status:r.status, text:t }; }); })
        .then(function(res){
          if (/^\s*</.test(res.text)){
            SYNC_MSG = /file you have requested does not exist/i.test(res.text)
              ? "Sheet sync failed \u2014 that Apps Script deployment no longer exists. Create a new deployment and update the endpoint URL."
              : /accounts\.google\.com|ServiceLogin|Sign in/i.test(res.text)
              ? "Sheet sync blocked \u2014 the web app isn't public. Re-deploy it with \u201cWho has access: Anyone.\u201d"
              : "Sheet sync failed \u2014 the script returned an error page. Check the tab is named \u201cEntries.\u201d";
            console.warn("[8\u00b78\u00b78] sheet read failed", res.status, res.text.slice(0,300));
            return;
          }
          var rows;
          try { rows = JSON.parse(res.text); }
          catch(err){
            SYNC_MSG = "Sheet sync failed \u2014 the response wasn't valid JSON.";
            console.warn("[8\u00b78\u00b78] JSON parse failed", err, res.text.slice(0,300));
            return;
          }
          if (!Array.isArray(rows)){
            SYNC_MSG = "Sheet sync failed \u2014 expected a list of rows.";
            return;
          }
          var mapped = rows.map(mapSheetRow);
          ENTRIES = mapped.filter(function(r){ return r.email || r.name; });
          if (rows.length && !ENTRIES.length){
            SYNC_MSG = "Sheet returned " + rows.length + " row(s) but no email/name column could be read \u2014 check the header row.";
          } else {
            SYNC_MSG = "";
            console.log("[8\u00b78\u00b78] loaded " + ENTRIES.length + " check-ins from Google Sheets");
          }
          saveLocal();
        })
        .catch(function(err){
          SYNC_MSG = "Sheet sync failed \u2014 couldn't reach the endpoint.";
          console.warn("[8\u00b78\u00b78] fetch error", err);
        });
    }
    function pushSheet(entry){
      return fetch(ENDPOINT, { method:"POST",
        headers:{ "Content-Type":"text/plain;charset=utf-8" },
        body: JSON.stringify(entry) }).catch(function(){});
    }
    /* Delete on the sheet. Omit date to remove every day for that email.
       Requires the updated Apps Script doPost (see LEADERBOARD-google-sheets.md). */
    function deleteSheet(email, date){
      if (!LIVE) return Promise.resolve();
      return fetch(ENDPOINT, { method:"POST",
        headers:{ "Content-Type":"text/plain;charset=utf-8" },
        body: JSON.stringify({ action:"delete", email:email, date:date || "" }) }).catch(function(){});
    }
    function removeEntry(email, date){
      var k = String(email||"").toLowerCase().trim();
      ENTRIES = ENTRIES.filter(function(e){
        return !(keyOf(e) === k && (!date || e.date === date));
      });
      saveLocal();
    }

    // ======================================================================
    // AGGREGATION + RANGE
    // ======================================================================
    function daysBefore(ref, n){
      var out = [], d = new Date(ref + "T00:00:00");
      for (var k = 0; k < n; k++){ out.push(d.toISOString().slice(0,10)); d.setDate(d.getDate()-1); }
      return out;
    }
    function rangeFor(s){
      switch (s.mode){
        case "day":    return [s.day];
        case "week":   return daysBefore(REF, 7);
        case "month":  return SEASON_DAYS.filter(function(d){ return d.slice(0,7) === REF.slice(0,7); });
        case "custom": return SEASON_DAYS.filter(function(d){ return d >= s.from && d <= s.to; });
        default:       return SEASON_DAYS.slice();   // "full" = whole season
      }
    }
    /* Longest run of CONSECUTIVE qualifying days anywhere in the season.
       This is what lets a self-selected window (e.g. 8/12-8/19) finish. */
    function bestRun(a, qualOf, kind){
      var best=0, bestStart=null, run=0, runStart=null;
      for (var i=0; i<SEASON_DAYS.length; i++){
        var ds = SEASON_DAYS[i];
        var d = a.byDate ? a.byDate[ds] : null;
        if (d && qualOf(d)[kind]){
          if (run === 0) runStart = ds;
          run++;
          if (run > best){ best = run; bestStart = runStart; }
        } else {
          run = 0;
        }
      }
      return { len: Math.min(best, STREAK_LEN), raw: best, start: bestStart };
    }
    function aggregate(a, range, isFull){
      var goal = goalOf(a.category);
      var declared = a.category;
      function qualOf(d){
        var dcat = d.cat || declared;
        var steps = dcat === "open" ? d.value : d.value * STEPS_PER_MILE;
        var sleepOk = d.hours >= 8;
        return {
          steps: steps,
          shown: declared === "open" ? steps : (dcat === "elite" ? d.value : d.value / STEPS_PER_MILE),
          elite: sleepOk && dcat === "elite" && d.value >= GOAL.elite,
          open:  sleepOk && steps >= GOAL.open
        };
      }
      var rows = a.days.filter(function(d){ return range.indexOf(d.date) !== -1; });
      var val=0, vN=0, hSum=0, hN=0, sSum=0, sN=0, eliteInRange=0, openInRange=0;
      rows.forEach(function(d){
        var q = qualOf(d);
        val += q.shown; if (d.value>0) vN++;
        if (d.hours>0){ hSum+=d.hours; hN++; }
        if (d.score!=null){ sSum+=d.score; sN++; }
        if (q.elite) eliteInRange++;
        if (q.open)  openInRange++;
      });

      // Totals = every qualifying day in range (the honest "days completed").
      // Streak = best run of CONSECUTIVE qualifying days (drives finisher status).
      var n, winStart=null, winEnd=null;
      var eliteStreak=eliteInRange, openStreak=openInRange;
      if (isFull){
        var be = bestRun(a, qualOf, "elite");
        var bo = bestRun(a, qualOf, "open");
        eliteStreak = be.len; openStreak = bo.len;
        n = STREAK_LEN;
        var b = (be.raw >= bo.raw) ? be : bo;
        if (b.start){
          winStart = b.start;
          winEnd = addDays(b.start, Math.min(b.raw, STREAK_LEN) - 1);
        }
      } else {
        n = range.length;
      }

      var tier = eliteStreak >= n ? "elite" : (openStreak >= n ? "open" : null);
      return {
        value: val,
        avgPerDay: vN ? val/vN : 0,
        progress: goal*n ? val/(goal*n) : 0,
        avgHours: hN ? +(hSum/hN).toFixed(1) : 0,
        avgScore: sN ? Math.round(sSum/sN) : null,
        eliteDays: eliteInRange,
        openDays: openInRange,
        // Total qualifying days — what athletes actually count.
        complete: declared === "elite" ? eliteInRange : openInRange,
        // Longest consecutive run — what earns finisher status.
        streak: declared === "elite" ? eliteStreak : openStreak,
        tier: tier,
        dropped: declared === "elite" && eliteStreak < n && openStreak >= n,
        winStart: winStart,
        winEnd: winEnd,
        daysInRange: n
      };
    }
    function tierRank(g){ return g.tier === "elite" ? 2 : g.tier === "open" ? 1 : 0; }

    // ======================================================================
    // RENDER
    // ======================================================================
    var state = { mode:"full", day:REF, from:SEASON.start, to:SEASON.end, program:"all", sort:"complete" };
    function esc(s){ return String(s).replace(/[&<>"]/g,function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
    function fmtDate(iso){ return new Date(iso+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}); }
    function fmtVal(v, cat){ return cat==="open" ? Math.round(v).toLocaleString("en-US") : (Math.round(v*10)/10).toFixed(1); }
    function srcBadge(src){ return '<span class="badge '+src.toLowerCase()+'">'+esc(src)+'</span>'; }
    function catTag(cat){ return '<span class="cat-tag '+cat+'">'+(cat==="open"?"Open":"Elite")+'</span>'; }
    function $(sel){ return root.querySelector(sel); }

    function currentData(){
      var users = athletesFromEntries(ENTRIES);
      var all = (LIVE || !USE_SAMPLE) ? users : sampleAthletes().concat(users);
      if (state.program !== "all") all = all.filter(function(a){ return a.category === state.program; });
      return all;
    }

    function render(){
      var isFull = state.mode === "full";
      var range = rangeFor(state);
      var rows = currentData().map(function(a){ return { a:a, g:aggregate(a, range, isFull) }; });
      rows.sort(function(x,y){
        if (state.sort==="activity") return y.g.progress - x.g.progress;
        if (state.sort==="score")    return (y.g.avgScore||0) - (x.g.avgScore||0);
        if (state.sort==="hours")    return y.g.avgHours - x.g.avgHours;
        if (tierRank(y.g) !== tierRank(x.g)) return tierRank(y.g) - tierRank(x.g);
        if (y.g.complete !== x.g.complete) return y.g.complete - x.g.complete;
        return y.g.progress - x.g.progress;
      });
      var tbody = $(".lb-tbody");
      if (!rows.length){
        tbody.innerHTML = '<tr><td colspan="7" class="lb-blank">No check-ins yet for this range. Hit <b>＋ Log my day</b> to add the first one.</td></tr>';
      } else {
        tbody.innerHTML = rows.map(function(r, idx){
          var a=r.a, g=r.g, cat=a.category;
          var finTag = (state.mode==="full" && g.tier)
            ? ' <span class="fin-tag '+g.tier+'">'+(g.tier==="elite"?"Elite Finisher":"Open Finisher")+'</span>'
            : '';
          var daysCell = '<span class="days-pill'+(g.tier?' done':'')+'">'+g.complete+'<small>/'+g.daysInRange+'</small></span>'
            + (g.dropped ? '<span class="drop-note" title="Missed the 8-mile bar, but cleared 8,000 steps every day">Open '+g.openDays+'/'+g.daysInRange+'</span>' : '')
            + (isFull && !g.tier && g.streak < g.complete
                ? '<span class="win-note" title="Longest run of consecutive qualifying days">Best streak '+g.streak+'</span>' : '')
            + (isFull && g.winStart && g.winStart !== WINDOW[0]
                ? '<span class="win-note" title="This athlete\u2019s own '+STREAK_LEN+'-day window">'+fmtDate(g.winStart)+'\u2013'+fmtDate(g.winEnd)+'</span>' : '');
          var scoreCell = g.avgScore!=null
            ? '<span class="lb-score">'+g.avgScore+'</span><span class="sub">sleep score</span>'
            : '<span class="lb-score muted">—</span><span class="sub">no device</span>';
          return '<tr class="'+(idx<3?"top":"")+'">'
            + '<td class="lb-rank">'+(idx+1)+'</td>'
            + '<td><div class="lb-athlete"><span class="nm">'+esc(a.name||"—")
              + finTag+'</span>'
              + '<span class="meta">'+catTag(cat)+' '+(a.instagram?'@'+esc(a.instagram):'')
              + (a.city?(a.instagram?' · ':'')+esc(a.city)+(a.state?', '+esc(a.state):''):'')+'</span></div></td>'
            + '<td class="lb-sleep"><span class="hrs">'+g.avgHours.toFixed(1)+'<small>h</small></span><span class="sub">avg in bed</span></td>'
            + '<td class="lb-sleep">'+scoreCell+'</td>'
            + '<td>'+srcBadge(a.source)+(a.verified?' <span class="verified" title="Device-verified">✓</span>':'')+'</td>'
            + '<td class="lb-act"><span class="act-num">'+fmtVal(g.value,cat)+'<small>'+unitOf(cat)+'</small></span>'
              + '<span class="act-sub">'+fmtVal(g.avgPerDay,cat)+' '+unitOf(cat)+'/day</span></td>'
            + '<td class="lb-days">'+daysCell+'</td>'
            + '</tr>';
        }).join("");
      }
      var label = ({ full:"Days completed", day:"Single day", week:"Past 7 days", month:"This month", custom:"Custom range" })[state.mode];
      var prog = state.program==="all" ? "" : " · "+(state.program==="open"?"Open":"Elite")+" only";
      $(".lb-rangelabel").textContent = label + (state.mode==="day" ? " · "+fmtDate(state.day) : "") + prog;
      var banner = root.querySelector("[data-syncerr]");
      if (banner){ banner.hidden = !SYNC_MSG; banner.textContent = SYNC_MSG || ""; }
    }

    // ======================================================================
    // MARKUP
    // ======================================================================
    function buildToolbar(){
      return '<div class="lb-toolbar"><div class="lb-filters">'
        + '<div class="lb-field"><label>Range</label><div class="seg" data-seg="range">'
          + '<button data-mode="full" class="active">Full</button><button data-mode="day">Day</button>'
          + '<button data-mode="week">Week</button><button data-mode="month">Month</button><button data-mode="custom">Custom</button></div></div>'
        + '<div class="lb-field" data-field-day hidden><label>Pick a day</label><input type="date" data-sel="day" min="'+SEASON.start+'" max="'+SEASON.end+'" value="'+state.day+'"></div>'
        + '<div class="lb-field" data-field-custom hidden><label>From → To</label><div class="lb-daterange">'
          + '<input type="date" data-dt="from" min="'+SEASON.start+'" max="'+SEASON.end+'" value="'+SEASON.start+'">'
          + '<span class="to">→</span>'
          + '<input type="date" data-dt="to" min="'+SEASON.start+'" max="'+SEASON.end+'" value="'+SEASON.end+'"></div></div>'
        + '<div class="lb-field"><label>Program</label><div class="seg" data-seg="program">'
          + '<button data-prog="all" class="active">All</button>'
          + '<button data-prog="elite">Elite</button><button data-prog="open">Open</button></div></div>'
        + '<div class="lb-field"><label>Sort by</label><select data-sel="sort">'
          + '<option value="complete">Days completed</option><option value="activity">Goal progress</option>'
          + '<option value="score">Sleep score</option><option value="hours">Hours slept</option></select></div>'
        + '</div><div class="lb-actions">'
        + '<button class="btn-log" data-btn="log">＋ Log my day</button>'
        + '<button class="btn-manage" data-btn="manage">Manage entries</button>'
        + '</div></div>';
    }
    function buildManagePanel(){
      return '<div class="lb-manage" data-manage hidden>'
        + '<div class="lb-manual-head"><b>Manage check-ins</b>'
        + '<span>Look up an email to edit or remove logged days.'
        + (ADMIN ? ' <b>Admin mode:</b> every check-in is listed below.' : '')
        + '</span></div>'
        + (ADMIN ? '' : '<div class="lb-lookup"><input type="email" data-lookup placeholder="you@email.com">'
          + '<button type="button" class="btn-gold" data-btn="lookup">Find my check-ins</button></div>')
        + '<div data-manage-list></div></div>';
    }
    function renderManageList(){
      var host = root.querySelector("[data-manage-list]");
      var email = ADMIN ? "" : ((root.querySelector("[data-lookup]")||{}).value || "").toLowerCase().trim();
      if (!ADMIN && !email){ host.innerHTML = ""; return; }
      var mine = ENTRIES.filter(function(e){ return ADMIN || keyOf(e) === email; })
        .slice().sort(function(a,b){ return (a.email+a.date) < (b.email+b.date) ? -1 : 1; });
      if (!mine.length){
        host.innerHTML = '<p class="lb-manage-empty">No check-ins found'+(email?' for '+esc(email):'')+'.</p>';
        return;
      }
      host.innerHTML = '<table class="lb-manage-table"><thead><tr>'
        + '<th>Athlete</th><th>Day</th><th>Program</th><th>Activity</th><th>Sleep</th><th></th>'
        + '</tr></thead><tbody>'
        + mine.map(function(e){
            var cat = catOf(e.category);
            return '<tr><td><b>'+esc(e.name||"—")+'</b><span class="em">'+esc(e.email||"")+'</span></td>'
              + '<td>'+fmtDate(e.date)+'</td>'
              + '<td>'+catTag(cat)+'</td>'
              + '<td>'+fmtVal(+e.value||0, cat)+' '+unitOf(cat)+'</td>'
              + '<td>'+(+e.hours||0).toFixed(1)+'h</td>'
              + '<td><button type="button" class="btn-del" data-del-email="'+esc(e.email||"")+'" data-del-date="'+esc(e.date)+'" title="Delete this day">✕</button></td></tr>';
          }).join("")
        + '</tbody></table>'
        + '<div class="lb-manage-foot"><button type="button" class="btn-text danger" data-btn="del-all">'
        + (ADMIN ? 'Delete ALL check-ins' : 'Delete all '+mine.length+' day'+(mine.length===1?'':'s')+' for this email')
        + '</button><span class="lb-manage-status"></span></div>';
    }
    function buildShell(){
      return '<div class="lb-syncerr" data-syncerr hidden></div>'
        + '<div class="board-shell"><div class="board-bar">'
        + '<span class="bt">8·8·8 Finisher Board</span>'
        + '<span class="status"><span class="dot"></span> <span class="lb-rangelabel">Full challenge</span> · '
        + (LIVE ? "live · Google Sheets" : "sample data + your saved check-ins") + '</span></div>'
        + '<div class="lb-table-wrap"><table class="lb"><thead><tr>'
        + '<th>#</th><th>Athlete</th><th>Sleep</th><th>Score</th><th>Device</th><th>Activity</th><th>Days</th>'
        + '</tr></thead><tbody class="lb-tbody"></tbody></table></div></div>';
    }
    function buildManualForm(){
      return '<form class="lb-manual" data-manual hidden>'
        + '<div class="lb-manual-head"><b>Manual check-in</b><span>Log a day by hand \u2014 we match on your email, so logging more days updates your one row. '
        + 'Any '+STREAK_LEN+' consecutive days between '+fmtDate(SEASON.start)+' and '+fmtDate(SEASON.end)+' count. '
        + 'Elite runners: a day under 8 miles still counts toward Open if it clears 8,000 steps.</span></div>'
        + '<div class="lb-manual-grid">'
        + '<label>Email<input type="email" name="email" required placeholder="you@email.com"></label>'
        + '<label>Name<input type="text" name="name" required placeholder="First Last"></label>'
        + '<label>Instagram<input type="text" name="instagram" placeholder="handle"></label>'
        + '<label>City<input type="text" name="city" placeholder="City"></label>'
        + '<label>State<input type="text" name="state" maxlength="2" placeholder="ST"></label>'
        + '<label>Program<select name="category" data-cat><option value="elite">Elite — 8 mi/day</option><option value="open">Open — 8,000 steps/day</option></select></label>'
        + '<label>Day<input type="date" name="date" min="'+SEASON.start+'" max="'+SEASON.end+'" value="'+TODAY+'"></label>'
        + '<label><span data-val-cap>Miles run</span><input type="number" name="value" data-val min="0" step="any" inputmode="decimal" placeholder="0"></label>'
        + '<label>Hours in bed<input type="number" name="hours" min="0" max="14" step="any" inputmode="decimal" placeholder="0"></label>'
        + '</div><div class="lb-manual-actions">'
        + '<button type="submit" class="btn-gold">Save check-in</button>'
        + '<button type="button" class="btn-text" data-btn="cancel">Cancel</button>'
        + '<span class="lb-manual-status"></span></div></form>';
    }
    function buildConnect(){
      return '<div class="lb-connect"><div class="ct"><b>Phase 2 — auto-sync.</b> Connect a device and your daily activity + sleep post to the board automatically, marked device-verified.</div>'
        + '<div class="connect-btns">'
        + '<button class="btn-connect" disabled>Oura <span class="soon">Soon</span></button>'
        + '<button class="btn-connect" disabled>Whoop <span class="soon">Soon</span></button>'
        + '<button class="btn-connect" disabled>Strava <span class="soon">Soon</span></button>'
        + '</div></div>';
    }

    function applyModeVisibility(){
      root.querySelector("[data-field-day]").hidden    = state.mode !== "day";
      root.querySelector("[data-field-custom]").hidden = state.mode !== "custom";
    }
    function applyValCap(){
      var cat = $("[data-cat]").value;
      var cap = $("[data-val-cap]");
      var inp = $("[data-val]");
      // step stays "any" — a fixed step rejects real values like 8121 steps or
      // 8.03 hours with a bare "Enter a valid value" browser error.
      if (cat === "open"){ cap.textContent = "Steps"; inp.placeholder = "8000"; }
      else { cap.textContent = "Miles run"; inp.placeholder = "8"; }
    }

    function wire(){
      root.querySelector('[data-seg="range"]').addEventListener("click", function(e){
        var b=e.target.closest("button[data-mode]"); if(!b) return;
        [].forEach.call(this.children,function(c){c.classList.remove("active");});
        b.classList.add("active"); state.mode=b.dataset.mode; applyModeVisibility(); render();
      });
      root.querySelector('[data-seg="program"]').addEventListener("click", function(e){
        var b=e.target.closest("button[data-prog]"); if(!b) return;
        [].forEach.call(this.children,function(c){c.classList.remove("active");});
        b.classList.add("active"); state.program=b.dataset.prog; render();
      });
      $('[data-sel="day"]').addEventListener("change", function(){ state.day=this.value; render(); });
      $('[data-sel="sort"]').addEventListener("change", function(){ state.sort=this.value; render(); });
      $('[data-dt="from"]').addEventListener("change", function(){ state.from=this.value; render(); });
      $('[data-dt="to"]').addEventListener("change", function(){ state.to=this.value; render(); });

      // ---- manage / delete panel ----
      var manage = root.querySelector("[data-manage]");
      root.querySelector('[data-btn="manage"]').addEventListener("click", function(){
        manage.hidden = !manage.hidden;
        if (!manage.hidden) renderManageList();
      });
      if (!ADMIN){
        root.querySelector('[data-btn="lookup"]').addEventListener("click", renderManageList);
        root.querySelector("[data-lookup]").addEventListener("keydown", function(e){
          if (e.key === "Enter"){ e.preventDefault(); renderManageList(); }
        });
      }
      manage.addEventListener("click", function(e){
        var del = e.target.closest("[data-del-email]");
        var st;
        if (del){
          removeEntry(del.getAttribute("data-del-email"), del.getAttribute("data-del-date"));
          deleteSheet(del.getAttribute("data-del-email"), del.getAttribute("data-del-date"));
          renderManageList(); render();
          st = root.querySelector(".lb-manage-status");
          if (st) st.textContent = LIVE ? "Deleted — syncing to Google Sheets…" : "Deleted";
          return;
        }
        if (e.target.closest('[data-btn="del-all"]')){
          var email = ADMIN ? "" : ((root.querySelector("[data-lookup]")||{}).value || "").toLowerCase().trim();
          var targets = ENTRIES.filter(function(x){ return ADMIN || keyOf(x) === email; });
          if (!targets.length) return;
          if (!confirm("Delete " + targets.length + " check-in" + (targets.length===1?"":"s") + "? This can't be undone.")) return;
          var emails = {};
          targets.forEach(function(x){ emails[String(x.email||"").toLowerCase()] = 1; });
          if (ADMIN){ ENTRIES = []; saveLocal(); } else { removeEntry(email); }
          Object.keys(emails).forEach(function(em){ deleteSheet(em); });
          renderManageList(); render();
          st = root.querySelector(".lb-manage-status");
          if (st) st.textContent = LIVE ? "Deleted — syncing to Google Sheets…" : "Deleted";
        }
      });

      var form = root.querySelector("[data-manual]");
      var status = root.querySelector(".lb-manual-status");
      $("[data-cat]").addEventListener("change", applyValCap);
      root.querySelector('[data-btn="log"]').addEventListener("click", function(){
        form.hidden = !form.hidden; status.textContent = "";
      });
      root.querySelector('[data-btn="cancel"]').addEventListener("click", function(){ form.hidden = true; });
      form.addEventListener("submit", function(e){
        e.preventDefault();
        if (!form.checkValidity()){ form.reportValidity(); return; }
        var f = new FormData(form);
        var entry = {
          email:(f.get("email")||"").trim(), name:(f.get("name")||"").trim(),
          instagram:(f.get("instagram")||"").replace(/^@/,"").trim(),
          city:(f.get("city")||"").trim(), state:(f.get("state")||"").toUpperCase().trim(),
          category:catOf(f.get("category")), date:f.get("date"),
          value:+(f.get("value")||0), hours:+(f.get("hours")||0)
        };
        var existed = ENTRIES.some(function(x){ return keyOf(x)===keyOf(entry); });
        upsertEntry(ENTRIES, entry); saveLocal(); render();
        if (LIVE) pushSheet(entry);
        ["value","hours"].forEach(function(n){ form.elements[n].value = ""; });
        status.textContent = (existed ? "Updated " : "Added ") + fmtDate(entry.date)
          + (LIVE ? " — syncing to Google Sheets…" : " — saved to this browser");
      });
    }

    // --- mount ---
    // Panels sit directly under the toolbar buttons so opening one is visible
    // immediately — below the tall board they'd open off-screen.
    root.innerHTML = buildToolbar() + buildManualForm() + buildManagePanel() + buildShell() + buildConnect();
    applyModeVisibility();
    wire();
    applyValCap();
    ENTRIES = loadLocal();
    render();
    if (LIVE) fetchSheet().then(render);
  }

  function init(){ document.querySelectorAll("[data-lg888-board]").forEach(boot); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
